import svgTrophyLarge from 'web/public/svg/150-borderless/trophy.svg';
import svgTrophySmall from 'web/public/svg/28/trophy.svg';

import svgWeightsLarge from 'web/public/svg/150-borderless/weights.svg';
import svgWeightsSmall from 'web/public/svg/28/weights.svg';

import svgGearLarge from 'web/public/svg/150-borderless/gear.svg';
import svgGearSmall from 'web/public/svg/28/gear.svg';

import svgRelicLarge from 'web/public/svg/150-borderless/relic.svg';
import svgRelicSmall from 'web/public/svg/28/relic.svg';

import svgTalentsLarge from 'web/public/svg/150-borderless/talents.svg';
import svgTalentsSmall from 'web/public/svg/28/talents.svg';

import svgQuickLarge from 'web/public/svg/150-borderless/attr-agi.svg';
import svgQuickSmall from 'web/public/svg/28/attr-agi.svg';

import svgAdvancedLarge from 'web/public/svg/150-borderless/options.svg';
import svgAdvancedSmall from 'web/public/svg/28/options.svg';

import svgOptionsLarge from 'web/public/svg/150-borderless/quick.svg';
import svgOptionsSmall from 'web/public/svg/28/quick.svg';

import svgCharImportLarge from 'web/public/svg/150-borderless/char-import.svg';
import svgCharImportSmall from 'web/public/svg/28/char-import.svg';

import svgInputLarge from 'web/public/svg/150-borderless/input.svg';
import svgInputSmall from 'web/public/svg/28/input.svg';

import svgAplLarge from 'web/public/svg/150-borderless/code-apl.svg';
import svgAplSmall from 'web/public/svg/28/code-apl.svg';

import svgReportOptionsLarge from 'web/public/svg/150-borderless/mag-glass.svg';
import svgReportOptionsSmall from 'web/public/svg/28/mag-glass.svg';

import svgShowInputLarge from 'web/public/svg/150-borderless/attr-int.svg';
import svgShowInputSmall from 'web/public/svg/28/attr-int.svg';

import svgBangLarge from 'web/public/svg/150-borderless/attr-crit.svg';
import svgBangSmall from 'web/public/svg/28/attr-crit.svg';

import svgYinyangLarge from 'web/public/svg/150-borderless/attr-vers.svg';
import svgYinyangSmall from 'web/public/svg/28/attr-vers.svg';

import svgDieLarge from 'web/public/svg/150-borderless/die.svg';
import svgDieSmall from 'web/public/svg/28/die.svg';

export default {
  optimize: {
    large: svgTrophyLarge,
    small: svgTrophySmall,
  },
  stats: {
    large: svgWeightsLarge,
    small: svgWeightsSmall,
  },
  quick: {
    large: svgQuickLarge,
    small: svgQuickSmall,
  },
  gear: {
    large: svgGearLarge,
    small: svgGearSmall,
  },
  relic: {
    large: svgRelicLarge,
    small: svgRelicSmall,
  },
  talents: {
    large: svgTalentsLarge,
    small: svgTalentsSmall,
  },
  advanced: {
    large: svgAdvancedLarge,
    small: svgAdvancedSmall,
  },
  options: {
    large: svgOptionsLarge,
    small: svgOptionsSmall,
  },
  charImport: {
    large: svgCharImportLarge,
    small: svgCharImportSmall,
  },
  input: {
    large: svgInputLarge,
    small: svgInputSmall,
  },
  apl: {
    large: svgAplLarge,
    small: svgAplSmall,
  },
  reportOptions: {
    large: svgReportOptionsLarge,
    small: svgReportOptionsSmall,
  },
  showInput: {
    large: svgShowInputLarge,
    small: svgShowInputSmall,
  },
  bang: {
    large: svgBangLarge,
    small: svgBangSmall,
  },
  yinyang: {
    large: svgYinyangLarge,
    small: svgYinyangSmall,
  },
  die: {
    large: svgDieLarge,
    small: svgDieSmall,
  },
};
